const appName = 'SGTraDex Pitstop';
const DEX_TYPE = {
	SGTRADEX: 'sgtradex',
	SGBUILDEX: 'sgbuildex',
	SGHEALTHDEX: 'sghealthdex'
}

const userRole = {
	SUPER_ADMIN: "Super Admin",
	ADMIN: "Admin User",
	TECH_USER: "Tech User",
	OPS_USER: "Operation User",
	ETR_USER: "Etr User"
}

export {
	appName,
	DEX_TYPE,
	userRole
}
